import request from '@/utils/request'
import config from '@/config'

export default {
  login (params) {
    return request.post(config.ApiYJ + '/auth', params)
  },
  getPublicKey(params) {
    return request.get(config.ApiYJ + '/auth/getPublicKey', { params })
  },
  getUserInfo (id) {
    return request.get(config.ApiYJ + '/account/getUserInfo', { params: { id } })
  },
  getMenuInfo (Grade) {
    return request.get(config.ApiYJ + '/account/menu', { params: Grade })
  },
  // 修改密码
  changePwd (params) {
    return request.post(config.ApiYJ + '/account/user_new', params)
  },
  logout () {
    return request.post(config.ApiYJ + '/auth/logout')
  },
  // getPublicKey () {
  //   return request.get(config.ApiYJ + '/account/get_publickey')
  // },
  // 水位设置
  getStationWaterInfo (params) {
    return request.get(config.ApiYSQ + '/HydrologyCenter/station_warn_water_info_new', { params })
  },
  saveStationWaterInfo (params) {
    return request.post(config.ApiYSQ + '/HydrologyCenter/save_station_warn_water_info', params)
  },
  // 河道水雨整合河道防洪指标
  getRiverListInfo (params) { // 获取河道列表
    return request.get(config.ApiYJ + '/synchronization/get_river_course_info', { params })
  },
  saveRiverListInfo (params) { // 保存河道列表
    return request.post(config.ApiYJ + '/synchronization/save_river_course_info', params)
  },
  getNestedFloorNav (params) { // 获取图标权限
    return request.get(config.ApiYJ + '/nav/get_nested_floor_nav', { params })
  },
  // 新增水位设置时间段接口
  getBackStationWaterInfo (params) { // 返回单站显示数据
    return request.get(config.ApiYSQ + '/HydrologyCenter/station_warn_water_info_new', { params })
  },
  batchSaveStationWaterInfo (params) { // 保存数据
    return request.post(config.ApiYSQ + '/HydrologyCenter/batchsave_station_warn_water_info', params)
  },
  // 重置密码
  resetPwd (params) {
    return request.post(config.ApiYJ + '/account/reset_password', params)
  },
  save_floor_nav (params) {
    return request.post(config.ApiYJ + '/nav/save_floor_nav', params)
  }
}
